import { Link } from "react-router-dom";

const ProdukBox = (props) => {
  const {
    id,
    nama,
    gambar,
    harga,
    data_produk_kategori,
    nama_toko,
    size = "small",
  } = props;

  const namaKategori = data_produk_kategori ? data_produk_kategori.nama : "";

  let width, height, nameTextSize, priceTextSize, noImagePath;

  switch (size) {
    case "small":
      width = "w-[9rem]";
      height = "h-[calc(4/5*9rem)]";
      nameTextSize = "text-sm";
      priceTextSize = "text-xs";
      noImagePath = "/no-image-small.jpg";
      break;
    case "medium":
      width = "w-[45vw] md:w-[23rem]";
      height = "h-[calc(4/5*45vw)] md:h-[calc(4/5*23rem)]";
      nameTextSize = "text-base";
      priceTextSize = "text-base";
      noImagePath = "/no-image-medium.jpg";
      break;
    case "large":
      width = "w-full";
      height = "h-[calc(4/5*100vw)]";
      nameTextSize = "text-base";
      priceTextSize = "text-base";
      noImagePath = "/no-image-medium.jpg";
      break;
    default:
      width = "w-[9rem]";
      height = "h-[5.0625rem]";
      break;
  }

  return (
    <div
      className={`col-start-start pb-2 ${size === "large" ? "w-full" : width}`}
    >
      <Link className="col-start-start gap-1 w-full" to={`/produk/${id}`}>
        <div className={`${width} ${height} bg-stone-100 rounded-md`}>
          <img
            className="w-full h-full object-cover rounded-md"
            src={gambar ? gambar : noImagePath}
          />
        </div>
        <div className="col-start-start gap-1">
          <span className={`${nameTextSize} text-slate-600 leading-tight`}>
            {nama}
          </span>
          <div className="row-start-center gap-1">
            <span
              className={`${priceTextSize} text-slate-600 font-semibold leading-none`}
            >
              {harga?.toLocaleString("id-ID")}
            </span>
            {nama_toko && (
              <span className="text-xs text-slate-500 italic">
                {" "}
                - {nama_toko}
              </span>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProdukBox;
